// src/utils/pdfWorkerConfig.js

import { GlobalWorkerOptions } from "pdfjs-dist";
import pdfjsPackage from "pdfjs-dist/package.json";

export const setPdfWorker = () => {
  const version = pdfjsPackage.version;
  GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
};
